const primary = '#1E5B79'
const textOnPrimary = 'white'
const secondary = '#35D6BB'
const textOnSecondary = 'white'

export const colors = {
  appBackground: secondary,
  primary,
  textOnPrimary,
  secondary,
  textOnSecondary,
  copy: '#8E8E93',
  copyDark: '#4A4A4A',
  copyLight: '#CAC9CB',
  navBg: '#FAF7F7',
  navIcon: '#888888',
  general: {
    red: '#B3071C',
    orange: '#ED9D1A',
    yellow: '#E6DA42',
    blue: '#6296D2',
    green: '#8AB85B',
  },
  buttons: {
    main: {
      color: primary,
      text: textOnPrimary,
      hoverColor: '#ed8f17',
      hoverText: textOnPrimary,
    },
    alternative: {
      color: 'white',
      text: primary,
      hoverColor: 'white',
      // TODO: darken this color with a JS lib?
      hoverText: '#ed8f17',
    },
  },
}



// WEBPACK FOOTER //
// ./src/module/colors.js